/* eslint-disable lit/binding-positions */
/* eslint-disable lit/no-invalid-html */
import { unsafeCSS } from 'lit';
import { html, literal } from 'lit/static-html.js';
import { classMap } from 'lit/directives/class-map.js';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BaseElement, customElement } from '../base-element';
import { logos } from '../../assets/logos';
import styles from './nav-logo.scss?inline';

@customElement('ps-nav-logo')
export class NavLogoWC extends BaseElement {
  static styles = unsafeCSS(styles);

  @property({ reflect: true }) href: string;

  @property({ reflect: true }) name?: keyof typeof logos;

  @property({ reflect: true, type: Boolean }) condensed?: boolean = false;

  private isLink() {
    return !!this.href;
  }

  render() {
    const classes = classMap({
      'c-nav-logo': true,
      'c-nav-logo--condensed': Boolean(this.condensed),
    });

    const isLink = this.isLink();
    const tag = isLink ? literal`a` : literal`button`;

    return html`
      <div class="${classes}">
        <${tag}
          href=${ifDefined(isLink ? this.href : undefined)}
          class="c-nav-logo__link"
          @click=${(e: Event) => {
            this.dispatchEvent(
              new CustomEvent('click', {
                detail: e,
                bubbles: true,
                composed: true,
              })
            );
          }}
        >
          ${
            this.name
              ? html`<img
                  src=${logos[this.name]}
                  width="32"
                  height="32"
                  alt=""
                />`
              : html`
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="c-nav-logo__img"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.31384 7.71082C5.2166 2.91652 10.4173 -0.00928526 16.0227 2.214e-05C22.9058 0.00976067 29.0112 4.42109 31.1823 10.9533C33.3533 17.4854 31.1034 24.6742 25.5958 28.8027C20.0881 32.9313 12.5573 33.0742 6.89697 29.1576C1.23663 25.241 -1.28441 18.1428 0.637266 11.533H16.3509C17.0924 11.5411 17.7915 11.7218 18.4106 12.0366C19.9093 12.818 20.9254 14.3917 20.9114 16.1954C20.9114 18.7704 18.8241 20.8579 16.2493 20.8579C13.6807 20.8429 11.6021 18.7642 11.5872 16.1954V15.1207H7.79263V16.1954C7.80736 20.8373 11.5493 24.6057 16.1907 24.6527H16.2571C20.9002 24.6401 24.6707 20.8972 24.7177 16.254V16.0977C24.7149 13.8982 23.8392 11.7898 22.2831 10.2355C20.7129 8.63255 18.5673 7.7236 16.3236 7.71082H2.31384Z"
                      fill="currentColor"
                    />
                  </svg>
                `
          }
          ${
            this.slotted()
              ? html`
                  <span class="c-nav-logo__text">
                    <span class="c-nav-logo__text-inner">
                      <slot class="c-nav-logo__slot"></slot>
                      ${this.slotted('suffix')
                        ? html`
                            <slot
                              class="c-nav-logo__suffix"
                              name="suffix"
                            ></slot>
                          `
                        : null}
                    </span>
                  </span>
                `
              : null
          }

        </${tag}>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-nav-logo': NavLogoWC;
  }

  enum PSElementTagNameMap {
    'ps-nav-logo' = 'ps-nav-logo',
  }
}
